export function zoomForViewport(
  viewport: google.maps.LatLngBounds,
  minZoom = 12,
  maxZoom = 21
) {
  const TILE_SIZE = 256

  const usableWidth = Math.max(1, 800)
  const usableHeight = Math.max(1, 400)

  const ne = viewport.getNorthEast()
  const sw = viewport.getSouthWest()

  let lngSpan = ne.lng() - sw.lng()
  if (lngSpan < 0) lngSpan += 360;

  const latRad = (lat: number) => {
    // Web Mercator clamp to avoid infinity at the poles
    const sin = Math.sin((lat * Math.PI) / 180)
    const clamped = Math.min(Math.max(sin, -0.9999), 0.9999)
    return Math.log((1 + clamped) / (1 - clamped)) / 2
  }

  const latFraction = Math.abs(latRad(ne.lat()) - latRad(sw.lat())) / Math.PI
  const lngFraction = lngSpan / 360

  const zoomX = Math.log2((usableWidth / TILE_SIZE) / lngFraction)
  const zoomY = Math.log2((usableHeight / TILE_SIZE) / latFraction)

  const zoom = Math.min(zoomX, zoomY)

  return Math.min(maxZoom, Math.max(minZoom, zoom))
}